import { Component, OnInit } from '@angular/core';
import { MaterialesService } from '../materiales.service';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-ry-media',
  templateUrl: './ry-media.component.html',
  styleUrls: ['./ry-media.component.css','../../assets/scss/styles.scss',
	'../../assets/scss/general-board.scss', 
    '../../assets/scss/fonts.scss',    
    '../../assets/ema/main.scss']
})
export class RyMediaComponent implements OnInit {
  public materiales;
  public contenido = this.contenidoService.getContenido("ry-media");
  constructor(private materialesService: MaterialesService, private contenidoService: ContenidoService) { }

  ngOnInit() {
    this.materialesService.getMaterialesByMarc('Royal')
      .then(materiales => {
        this.materiales = materiales;
      })
      .catch(err => console.error(err));
  }

}
